import { AnchorButton, Classes, Icon, Intent } from '@blueprintjs/core'
import * as React from 'react'
import { IconName } from '@blueprintjs/icons'

interface Props {
  iconName: IconName
  title: React.ReactNode
  message: string | React.ReactNode
  returnHome?: boolean
}

export default class FullScreenErrorMessage extends React.Component<Props> {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const { iconName, title, message, returnHome = true, ...otherProps } = this.props
    return (
      <div
        className="dl-err"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        {...otherProps}
      >
        <div style={{ marginTop: -150, maxWidth: 450, textAlign: 'center' }}>
          <Icon icon={iconName} style={{ marginBottom: 15 }} iconSize={150} color="#ccc" />
          <h2 style={{ marginBottom: 10 }}>{title}</h2>
          <p className={Classes.TEXT_MUTED} style={{ margin: '20px 0 40px' }}>
            {message}
          </p>
          {returnHome && (
            <AnchorButton href="/" intent={Intent.PRIMARY}>
              Return to home screen
            </AnchorButton>
          )}
        </div>
      </div>
    )
  }
}
